import React, { ReactNode } from 'react';

interface Props { children: ReactNode }

const ResponsiveGate: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};

export default ResponsiveGate;
